/**
 * Public-domain classics used as cover art inside the landing previews.
 * Shaped like the catalog books GeneratedBookCover already accepts, so the
 * covers look exactly like the real Library's.
 */
export const PREVIEW_BOOKS = {
  kokoro: { title: 'Kokoro', title_jp: 'こゝろ', author: 'Natsume Soseki', author_jp: '夏目漱石' },
  sangetsuki: { title: 'Sangetsuki', title_jp: '山月記', author: 'Nakajima Atsushi', author_jp: '中島敦' },
  rashomon: { title: 'Rashomon', title_jp: '羅生門', author: 'Akutagawa Ryunosuke', author_jp: '芥川龍之介' },
  melos: { title: 'Run, Melos!', title_jp: '走れメロス', author: 'Dazai Osamu', author_jp: '太宰治' },
  ginga: { title: 'Night on the Galactic Railroad', title_jp: '銀河鉄道の夜', author: 'Miyazawa Kenji', author_jp: '宮沢賢治' },
};
